import React from "react";
import InfoPage from "../InfoPage";
import "./HostResources.sass";

const resources = [
  {
    title: "The Kitchen Experience",
    subtitle: "Style & Guest Use Best Practices",
    href: "/resources/the-kitchen-experience.pdf",
    preview: "/resources/the-kitchen-experience-preview.jpg",
  },
  {
    title: "Guest Avatar Guide",
    subtitle: "A guide for designing your stay for the guests you want to attract",
    href: "/resources/guest-avatar-guide.pdf",
    preview: "/resources/guest-avatar-guide-preview.jpg",
  },
];

const HostResources = () => {
  const content = (
    <div className="host-resources-page">
      <div className="host-resources-header">
        <h2 className="host-resources-title">Host Resources</h2>
        <p className="host-resources-subtitle">
          Guides and best practices to help you design exceptional stays and successful collaborations.
        </p>
      </div>

      <div className="host-resources-grid">
        {resources.map((r) => (
          <a
            key={r.href}
            href={r.href}
            target="_blank"
            rel="noopener noreferrer"
            className="host-resource-card"
          >
            <img
              src={r.preview}
              alt={`${r.title} cover`}
              className="host-resource-cover"
            />
            <div>
              <h3 className="host-resource-name">{r.title}</h3>
              <p className="host-resource-description">{r.subtitle}</p>
              <span className="host-resource-download">Download PDF</span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );

  return <InfoPage below={content} disableStamps customMinHeight={600} showInlineLivePulse />;
};

export default HostResources;
